import styled from 'styled-components';

export const RequirementsContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
